<template>
  <div style="display:flex; width:100%;">
    <div class="col-md-12 padding-0">
      <div class="menu view-height col-med-4">
        <div class="tiles row">
          <div class="tile-wrapper">
            <div class="clear-tile">
              <div class="row">
                <div class="col-md-12">
                  <div class="small-tile-wrapper">
                    <div class="small-tile">
                      <p class="small-tile-title">
                        Anleitung:
                      </p>
                      <p class="tile-icon-message" style="line-height: 1.2;">
                        In diesem Bereich können Sie die Strukturen der
                        IoT-Applikation verwalten und organisieren. In der
                        hierarchisch aufgebauten Struktur konfigurieren Sie
                        Anwendungen bzw. Kind-Elemente ausgehend von Ihrem
                        Grundelement. Bei der Pflege der Kind-Elemente müssen
                        Sie die Anwendungs-ID angeben, die Sie in niota unter
                        der Anwendung finden. <br /><br />
                        Bei Fragen, wenden Sie sich bitte an <br />
                        den DIGIMONDO-Support unter <br />
                        support@digimondo.de.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-settings col-md-8">
        <div class="settings-main">
          <div
            class="settings-main__overlay"
            v-show="$loader.isLoading('saveMenuData')"
          >
            <spinner
              line-fg-color="#313942"
              line-bg-color="#eee"
              message="Daten werden gespeichert"
              :spacing="10"
              :size="16"
            ></spinner>
          </div>
          <div class="content-header">
            Einstellung Baumstruktur
          </div>
          <content-settings
            :settingsMenu="settingsMenu"
            :addFirst="addFirst"
            @saveMenu="saveMenu"
          ></content-settings>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import contentSettings from "./contentSettings";
import ApiService from "../services/api-service";
import UserService from "../services/user-service";
import Spinner from "vue-simple-spinner";
import get from "lodash/get";
import set from "lodash/set";

export default {
  name: "contentSettingsMain",
  components: {
    contentSettings,
    Spinner
  },
  menuData: {},
  data() {
    return {
      settingsMenu: [],
      addFirst: false,
      userData: UserService.getUser()
    };
  },
  mounted() {
    // this.getMenuFromAccount();
    this.getMenuFromAUser();
  },
  methods: {
    getMenuFromAccount() {
      let account = this.$store.state.account;
      if (account) {
        let accountMenu = get(account, "properties.appMenu");
        if (accountMenu && accountMenu.length > 0) {
          this.settingsMenu = accountMenu;
        } else {
          this.addFirst = true;
        }
        this.menuData = account;
      }
    },
    getMenuFromAUser() {
      let userMenu = get(this.userData, "properties.appMenu");
      if (userMenu && userMenu.length > 0) {
        this.settingsMenu = userMenu;
      } else {
        this.addFirst = true;
      }
      this.menuData = this.userData;
    },
    saveMenu() {
      let menu = get(this.menuData, "properties.appMenu");
      if (!menu || this.settingsMenu.length > 0) {
        set(this.menuData, "properties.appMenu", []);
        set(this.menuData, "properties.appMenu", this.settingsMenu);
      }
      this.updateUser();
      // this.updateAccount();
    },
    updateAccount() {
      this.menuData.name1 = this.menuData.name;
      this.menuData.address1 = this.menuData.data.n1_legacy.address1;
      this.menuData.color01 = "#163E73";
      this.menuData.color02 = "#163E73";
      ApiService.updateAccount(this.menuData)
        .then(result => {
          if (result.error) {
            this.$notify({
              type: "error",
              message: `Fehler beim Speichern der Daten`,
              position: "bottom-left"
            });
            this.loading = false;
            return;
          }
          this.$notify({
            type: "success",
            message: "Menu gespeichert",
            position: "bottom-right"
          });
        })
        .catch(() => {
          this.$notify({
            type: "error",
            message: "Fehler beim Speichern!",
            position: "bottom-right"
          });
        });
    },
    updateUser() {
      ApiService.updateUser(this.menuData)
        .then(result => {
          if (result.status !== 200) {
            this.$notify({
              type: "error",
              message: `Fehler beim Speichern der Daten`,
              position: "bottom-left"
            });
            this.loading = false;
            return;
          }
          this.$notify({
            type: "success",
            message: "Menu gespeichert",
            position: "bottom-right"
          });
        })
        .catch(error => {
          console.log(error);
          this.$notify({
            type: "error",
            message: "Fehler beim Speichern!",
            position: "bottom-right"
          });
        });
    }
  }
};
</script>
